module.exports = __webpack_public_path__ + "media/images/sp-icon-055139139cb1a444115542321a36097e.svg";